const defaultConfig = {
  apiServerBaseUrl: 'http://localhost:3000',
  submissionEmailAddress: 'testemailaddress@test.test',
  submissionPhoneNumber: '(555) 555-5555',
  environmentColor: '#90ee90',
  analyticsTrackerId: null,
};


export default defaultConfig;
